export const POLLING_INTERVAL = 15000;
